export const defaultBlockDecorator = ({ blockClassName, block, render }) => render({ blockClassName, block });
//# sourceMappingURL=defaultBlockDecorator.js.map